/* eslint-disable react/prop-types */

import React, { useContext, useEffect, useState } from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import { AppContext } from "~context/AppContext";
import ScreenHeight from "~components/ScreenHeight";
import ChevronDown from "~components/svg/ChevronDown";
import { sortArrayByPriority } from "~utils/helpers";

const Nav = () => {
  const {
    inventoryFetched,
    menuActive,
    setMenuActive,
    pathname,
    refreshInventoryCache
  } = useContext(AppContext);

  const [expanded, setExpanded] = useState(null);

  const {
    allSanityCollection,
    allShopifyProduct,
    allShopifyAdminProduct
  } = useStaticQuery(graphql`
    query Nav {
      allSanityCollection {
        edges {
          node {
            handle
            title
            priority
          }
        }
      }

      allShopifyProduct {
        edges {
          node {
            id
            title
            description
            handle
            images {
              originalSrc
            }
            productType
            vendor
            variants {
              id
              sku
              title
              image {
                originalSrc
              }
              price
              presentmentPrices {
                edges {
                  node {
                    price {
                      amount
                      currencyCode
                    }
                  }
                }
              }
              selectedOptions {
                name
                value
              }
            }
          }
        }
      }

      allShopifyAdminProduct {
        edges {
          node {
            products {
              handle
              title
              variants {
                alternative_id
                inventory_item_id
                sku
                title
              }
            }
          }
        }
      }
    }
  `);

  //

  const close = () => {
    setMenuActive(false);
  };

  //

  const collections = [];

  if (allSanityCollection?.edges?.[0]) {
    allSanityCollection.edges.forEach(({ node }) => {
      collections.push(node);
    });
  }

  sortArrayByPriority(collections);

  useEffect(() => {
    if (!inventoryFetched) {
      setTimeout(() => {
        refreshInventoryCache(allShopifyProduct, allShopifyAdminProduct);
      }, 100);
    }
  }, [pathname]);

  //

  return (
    <ScreenHeight className="fixed top-0 right-0 bottom-0 left-0 z-30 pointer-events-none">
      <nav
        className={`nav ${
          menuActive
            ? `active pointer-events-auto`
            : `opacity-0 pointer-events-none`
        } w-full h-full relative z-30 pt-24 bg-scarlet text-bone`}
      >
        {menuActive && (
          <div className="grid">
            <p className="animation-appear-down grid-end-12 relative block mt-2 b1 text-center">
              The best hair of your life
            </p>

            <ul className="grid-end-12 relative mt-8 border-orange">
              <li className="animation-appear-down animation-delay-1 w-full relative block border-t border-orange">
                <button
                  className="w-full h-12 relative block"
                  type="button"
                  onClick={() => {
                    setExpanded(expanded === `Shop` ? null : `Shop`);
                  }}
                >
                  <div className="w-full h-full flex items-center justify-between pl-3 pr-1">
                    <span className="f4">Shop</span>

                    <div
                      className="transition-transform relative block"
                      style={{
                        transform: `rotate(-${
                          expanded === `Shop` ? `` : `9`
                        }0deg)`
                      }}
                    >
                      <ChevronDown className="w-4" color="bone" />
                    </div>
                  </div>
                </button>

                {expanded === `Shop` && (
                  <div className="animation-appear-down-slow w-full relative block px-3 pb-5">
                    <ul className="relative">
                      {collections?.[0] &&
                        collections.map(collection => {
                          const key = collection.handle;

                          return (
                            <li
                              key={key}
                              className={`whitespace-no-wrap hover-underline f4 ${
                                pathname === `/collections/${collection.handle}`
                                  ? `underline`
                                  : ``
                              } uppercase`}
                            >
                              <Link
                                to={`/collections/${collection.handle}`}
                                className="block pt-2 pb-2"
                                onClick={close}
                              >
                                {collection.title}
                              </Link>
                            </li>
                          );
                        })}

                      <li className="whitespace-no-wrap hover-underline f4 uppercase">
                        <Link
                          to="/brands"
                          className={`${
                            pathname === `/brands` ? `underline` : ``
                          } block pt-2 pb-2`}
                          onClick={close}
                        >
                          Shop Brands
                        </Link>
                      </li>

                      <li className="whitespace-no-wrap hover-underline f4 uppercase">
                        <Link
                          to="/collections"
                          className={`${
                            pathname === `/collections` ? `underline` : ``
                          } block pt-2 pb-2`}
                          onClick={close}
                        >
                          Shop All
                        </Link>
                      </li>
                    </ul>
                  </div>
                )}
              </li>

              <li className="animation-appear-down animation-delay-2 w-full relative block border-t border-orange">
                <Link to="/contact">
                  <button
                    className="w-full h-12 relative block"
                    type="button"
                    onClick={() => {
                      close();
                      // setExpanded(expanded === `Contact` ? null : `Contact`);
                    }}
                  >
                    <div className="w-full h-full flex items-center justify-between pl-3 pr-1">
                      <span className="f4">Contact</span>

                      <div
                        className="transition-transform relative block"
                        style={{ transform: `rotate(-90deg)` }}
                      >
                        <ChevronDown className="w-4" color="bone" />
                      </div>
                    </div>
                  </button>

                  {/* {expanded === `Contact` && (
                <div className="animation-appear-down w-full relative block px-3 pb-5">
                  <p>thing</p>
                </div>
              )} */}
                </Link>
              </li>

              <li className="animation-appear-down animation-delay-3 w-full relative block border-t border-orange">
                <Link to="/careers">
                  <button
                    className="w-full h-12 relative block"
                    type="button"
                    onClick={() => {
                      close();
                      // setExpanded(expanded === `Careers` ? null : `Careers`);
                    }}
                  >
                    <div className="w-full h-full flex items-center justify-between pl-3 pr-1">
                      <span className="f4">Careers</span>

                      <div
                        className="transition-transform relative block"
                        style={{ transform: `rotate(-90deg)` }}
                      >
                        <ChevronDown className="w-4" color="bone" />
                      </div>
                    </div>
                  </button>

                  {/* {expanded === `Careers` && (
                <div className="animation-appear-down w-full relative block px-3 pb-5">
                  <p>thing</p>
                </div>
              )} */}
                </Link>
              </li>

              <li className="animation-appear-down animation-delay-3 w-full relative block border-t border-orange">
                <Link to="/services">
                  <button
                    className="w-full h-12 relative block"
                    type="button"
                    onClick={() => {
                      close();
                      // setExpanded(expanded === `Services` ? null : `Services`);
                    }}
                  >
                    <div className="w-full h-full flex items-center justify-between pl-3 pr-1">
                      <span className="f4">Services</span>

                      <div
                        className="transition-transform relative block"
                        style={{ transform: `rotate(-90deg)` }}
                      >
                        <ChevronDown className="w-4" color="bone" />
                      </div>
                    </div>
                  </button>

                  {/* {expanded === `Services` && (
                <div className="animation-appear-down w-full relative block px-3 pb-5">
                  <p>thing</p>
                </div>
              )} */}
                </Link>
              </li>

              <li className="animation-appear-down animation-delay-4 w-full relative block border-t border-b border-orange">
                <Link to="/about">
                  <button
                    className="w-full h-12 relative block"
                    type="button"
                    onClick={() => {
                      close();
                      // setExpanded(expanded === `About` ? null : `About`);
                    }}
                  >
                    <div className="w-full h-full flex items-center justify-between pl-3 pr-1">
                      <span className="f4">About</span>

                      <div
                        className="transition-transform relative block"
                        style={{ transform: `rotate(-90deg)` }}
                      >
                        <ChevronDown className="w-4" color="bone" />
                      </div>
                    </div>
                  </button>

                  {/* {expanded === `About` && (
                <div className="animation-appear-down w-full relative block px-3 pb-5">
                  <p>thing</p>
                </div>
              )} */}
                </Link>
              </li>

              <li className="animation-appear-down animation-delay-4 w-full relative block border-orange">
                <Link to="/joey-loves">
                  <button
                    className="w-full h-12 relative block"
                    type="button"
                    onClick={() => {
                      close();
                    }}
                  >
                    <div className="w-full h-full flex items-center justify-between pl-3 pr-1">
                      <span className="f4">Joey Loves</span>

                      <div
                        className="transition-transform relative block"
                        style={{ transform: `rotate(-90deg)` }}
                      >
                        <ChevronDown className="w-4" color="bone" />
                      </div>
                    </div>
                  </button>
                </Link>
              </li>

              <li className="animation-appear-down animation-delay-5 w-full relative block border-t border-b border-orange">
                <Link to="/search">
                  <button
                    className="w-full h-12 relative block"
                    type="button"
                    onClick={() => {
                      close();
                    }}
                  >
                    <div className="w-full h-full flex items-center justify-between pl-3 pr-1">
                      <span className="f4">Search</span>

                      <div
                        className="transition-transform relative block"
                        style={{ transform: `rotate(-90deg)` }}
                      >
                        <ChevronDown className="w-4" color="bone" />
                      </div>
                    </div>
                  </button>
                </Link>
              </li>
            </ul>
          </div>
        )}
      </nav>
    </ScreenHeight>
  );
};

export default Nav;
